import React, { Component, useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import SplitNumber from "../../_Components/SplitNumber";
import _ from "lodash";
import AgentWithdrawal from "../../../../core/api/api.agentWithdrawal";
import SwalMessage from "../../_Components/SwalMessage";
import Swal from "sweetalert2";

function DataGridAmusementServices({ data, callback }) {
  async function handleRemoveItem(ReqId, Reqstatus) {
    let HtmlOutPut = "آیا درخواست برداشت وجه به شماره " + ReqId + " کنسل شود؟";
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success px-5 py-2 mr-2",
        cancelButton: "btn btn-danger py-2  px-5",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "حذف عملیات",
        icon: "question",
        html: HtmlOutPut,
        type: "success",
        showConfirmButton: true,
        confirmButtonText: "   بله  ",

        showCancelButton: true,
        cancelButtonText: "   خیر ",
      })
      .then((result) => {
        if (result.value) {
          var rest = AgentWithdrawal.removeAgentWithdrawal({ Id: ReqId }).then(
            (result) => {
              SwalMessage({ title: result.message, iSsuccess: result.data });
              callback();
            }
          );
        }
      });
  }

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "شماره درخواست",
        minWidth: 50,
      },
      {
        Header: "مبلغ",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <SplitNumber number={row.original.rialAmount} />
          </div>
        ),
      },
      {
        accessor: "statusS",
        Header: "وضعیت",
        align: "center",

        minWidth: 100,
        Cell: ({ row }) => (
          <div
            className={
              row.original.isDeleted
                ? "text-danger  bg-light-danger text-center rounded-pill py-1 px-1"
                : row.original.status === 4
                  ? "text-danger  bg-light-danger text-center rounded-pill py-1 px-1"
                  : row.original.status === 3
                    ? "text-success  bg-light-success text-center rounded-pill py-1 px-1"
                    : row.original.status === 0 || row.original.status === 2
                      ? "text-secondary  bg-light text-center rounded-pill py-1 px-1"
                      : "text-primary  bg-light-primary text-center rounded-pill py-1 px-1"
            }
          >
            {row.original.isDeleted ? "حذف شده" : row.original.statusS}
          </div>
        ),
      },
      {
        accessor: "destinationAccountAccountNumber",
        Header: "به حساب",
        minWidth: 100,
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 100,
      },
      {
        Header: "تاریخ انجام",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.paymentDate)} -{" "}
            {_.toString(row.original.paymentTime)}
          </div>
        ),
      },

      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            {row.original.isDeleted ? (
              <></>
            ) : (
              <>
                <span
                  className="btn btn-light-danger btn-sm mr-2 btn-icon"
                  onClick={() => handleRemoveItem(row.original.id)}
                >
                  <i
                    className="far fa-trash-alt text-small"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="tooltip-dark"
                    title={"حذف درخواست"}
                    data-bs-delay-hide="10000"
                  ></i>
                </span>
              </>
            )}
          </div>
        ),
      },
    ],
    []
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
